"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactMapGl = require("react-map-gl");

var _baseMap = require("./base-map");

var _ENV$mapTiles$rail, _ENV, _ENV$mapTiles;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var tilesURL = (_ENV$mapTiles$rail = (_ENV = ENV) === null || _ENV === void 0 ? void 0 : (_ENV$mapTiles = _ENV.mapTiles) === null || _ENV$mapTiles === void 0 ? void 0 : _ENV$mapTiles.rail) !== null && _ENV$mapTiles$rail !== void 0 ? _ENV$mapTiles$rail : 'https://tiles.geo.nic-place.com/rail/{z}/{x}/{y}.png';

var RailLayer = function RailLayer() {
  var _useMapType = (0, _baseMap.useMapType)(),
      mapType = _useMapType.mapType,
      types = _useMapType.types; // rail tiles are not available for google


  if (mapType === types.google) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_reactMapGl.Source, {
    type: "raster",
    tileSize: 256,
    tiles: [tilesURL]
  }, /*#__PURE__*/_react["default"].createElement(_reactMapGl.Layer, {
    type: "raster"
  }));
};

var _default = RailLayer;
exports["default"] = _default;